import { gql } from "@apollo/client";

const ACCOUNTING_SYSTEM_INVOICE_FIELDS = `
  externalInvoiceId
  externalInvoiceDocumentNumber
  externalInvoiceCustomerId
  externalInvoiceOpenBalance
  externalInvoiceDate
  deductionPurchaserKey
  deductionPurchaserName
  linkedChecks {
    remittanceId
    checkNumber
    checkDate
    checkAmount
  }
`;

const GET_ACCOUNTING_SYSTEM_INVOICES_GROUPED = gql`
  query GetAccountingSystemInvoicesGrouped($params: GetAccountingSystemInvoicesGroupedParams!) {
    getAccountingSystemInvoicesGrouped(params: $params) {
      accountingSystemKey
      linkedCount
      unlinkedCount
      total
      data {
        linkedToCheck {
          ${ACCOUNTING_SYSTEM_INVOICE_FIELDS}
        }
        unlinked {
          ${ACCOUNTING_SYSTEM_INVOICE_FIELDS}
        }
      }
    }
  }
`;

export default GET_ACCOUNTING_SYSTEM_INVOICES_GROUPED;
